import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import vary from "../assets/images/vary.jpeg";
import { Link } from "react-router-dom";
import {
  Brans,
  EnvelopeIcon,
  MapPinIcon,
  PhoneIcon,
} from "@heroicons/react/24/outline";
import { useDispatch, useSelector } from "react-redux";
import { getContact } from "../../features/Global/ContactUs";
import { getConfiguration } from "../../features/Global/Configuration";
import Cookies from "js-cookie";

const Footer = () => {
  const { t } = useTranslation();
  const locale = localStorage.getItem("i18nextLng");
  const contacts = useSelector((state) => state.Contact.data);
  const Configuration = useSelector((state) => state.Configuration.data);

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getContact());
    dispatch(getConfiguration());
  }, []);
  return (
    <footer className="text-center text-gray-600 bg-white lg:text-left">
      <div className="flex items-center justify-center p-6 border-b border-gray-300 lg:justify-between">
        <div className="hidden mr-12 lg:block">
          <span className={`${locale}`}>{t("varySocialMedia")}</span>
        </div>
        <div className="flex justify-center">
          <a
            rel="noopener noreferrer"
            target="_blank"
            href="https://www.facebook.com/people/Vary-healthcare/100088835959195/"
            className="mx-3 text-blue-600 group"
          >
            <svg
              aria-hidden="true"
              focusable="false"
              data-prefix="fab"
              data-icon="facebook-f"
              className="w-3 duration-500 group-hover:scale-125"
              role="img"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 320 512"
            >
              <path
                fill="currentColor"
                d="M279.14 288l14.22-92.66h-88.91v-60.13c0-25.35 12.42-50.06 52.24-50.06h40.42V6.26S260.43 0 225.36 0c-73.22 0-121.08 44.38-121.08 124.72v70.62H22.89V288h81.39v224h100.17V288z"
              ></path>
            </svg>
          </a>
          {/* <a
            rel="noopener noreferrer"
            href="#!"
            className="mx-3 text-yellow-400 group"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              fill="currentColor"
              className="duration-500 bi bi-snapchat group-hover:scale-125"
              viewBox="0 0 16 16"
            >
              <path d="M15.943 11.526c-.111-.303-.323-.465-.564-.599a1.416 1.416 0 0 0-.123-.064l-.219-.111c-.752-.399-1.339-.902-1.746-1.498a3.387 3.387 0 0 1-.3-.531c-.034-.1-.032-.156-.008-.207a.338.338 0 0 1 .097-.1c.129-.086.262-.173.352-.231.162-.104.289-.187.371-.245.309-.216.525-.446.66-.702a1.397 1.397 0 0 0 .069-1.16c-.205-.538-.713-.872-1.329-.872a1.829 1.829 0 0 0-.487.065c.006-.368-.002-.757-.035-1.139-.116-1.344-.587-2.048-1.077-2.61a4.294 4.294 0 0 0-1.095-.881C9.764.216 8.92 0 7.999 0c-.92 0-1.76.216-2.505.641-.412.232-.782.53-1.097.883-.49.562-.96 1.267-1.077 2.61-.033.382-.04.772-.036 1.138a1.83 1.83 0 0 0-.487-.065c-.615 0-1.124.335-1.328.873a1.398 1.398 0 0 0 .067 1.161c.136.256.352.486.66.701.082.058.21.14.371.246l.339.221a.38.38 0 0 1 .109.11c.026.053.027.11-.012.217a3.363 3.363 0 0 1-.295.52c-.398.583-.968 1.077-1.696 1.472-.385.204-.786.34-.955.8-.128.348-.044.743.28 1.075.119.125.257.23.409.31a4.43 4.43 0 0 0 1 .4.66.66 0 0 1 .202.09c.118.104.102.26.259.488.079.118.18.22.296.3.33.229.701.243 1.095.258.355.014.758.03 1.217.18.19.064.389.186.618.328.55.338 1.305.802 2.566.802 1.262 0 2.02-.466 2.576-.806.227-.14.424-.26.609-.321.46-.152.863-.168 1.218-.181.393-.015.764-.03 1.095-.258a1.14 1.14 0 0 0 .336-.368c.114-.192.11-.327.217-.42a.625.625 0 0 1 .19-.087 4.446 4.446 0 0 0 1.014-.404c.16-.087.306-.2.429-.336l.004-.005c.304-.325.38-.709.256-1.047Zm-1.121.602c-.684.378-1.139.337-1.493.565-.3.193-.122.61-.34.76-.269.186-1.061-.012-2.085.326-.845.279-1.384 1.082-2.903 1.082-1.519 0-2.045-.801-2.904-1.084-1.022-.338-1.816-.14-2.084-.325-.218-.15-.041-.568-.341-.761-.354-.228-.809-.187-1.492-.563-.436-.24-.189-.39-.044-.46 2.478-1.199 2.873-3.05 2.89-3.188.022-.166.045-.297-.138-.466-.177-.164-.962-.65-1.18-.802-.36-.252-.52-.503-.402-.812.082-.214.281-.295.49-.295a.93.93 0 0 1 .197.022c.396.086.78.285 1.002.338.027.007.054.01.082.011.118 0 .16-.06.152-.195-.026-.433-.087-1.277-.019-2.066.094-1.084.444-1.622.859-2.097.2-.229 1.137-1.22 2.93-1.22 1.792 0 2.732.987 2.931 1.215.416.475.766 1.013.859 2.098.068.788.009 1.632-.019 2.065-.01.142.034.195.152.195a.35.35 0 0 0 .082-.01c.222-.054.607-.253 1.002-.338a.912.912 0 0 1 .197-.023c.21 0 .409.082.49.295.117.309-.04.56-.401.812-.218.152-1.003.638-1.18.802-.184.169-.16.3-.139.466.018.14.413 1.991 2.89 3.189.147.073.394.222-.041.464Z" />
            </svg>
          </a> */}
          <a
            rel="noopener noreferrer"
            target="_blank"
            href="https://www.instagram.com/vary_healthcare/"
            className="mx-3 text-rose-600 group"
          >
            <svg
              aria-hidden="true"
              focusable="false"
              data-prefix="fab"
              data-icon="instagram"
              className="w-4 duration-500 group-hover:scale-125"
              role="img"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 448 512"
            >
              <path
                fill="currentColor"
                d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z"
              ></path>
            </svg>
          </a>
          {/* <a
            rel="noopener noreferrer"
            href="https://t.me/varypharmacy"
            target="_blank"
            className="mx-3 text-cyan-600 group"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              fill="currentColor"
              className="duration-500 bi bi-telegram group-hover:scale-125"
              viewBox="0 0 16 16"
            >
              <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8.287 5.906c-.778.324-2.334.994-4.666 2.01-.378.15-.577.298-.595.442-.03.243.275.339.69.47l.175.055c.408.133.958.288 1.243.294.26.006.549-.1.868-.32 2.179-1.471 3.304-2.214 3.374-2.23.05-.012.12-.026.166.016.047.041.042.12.037.141-.03.129-1.227 1.241-1.846 1.817-.193.18-.33.307-.358.336a8.154 8.154 0 0 1-.188.186c-.38.366-.664.64.015 1.088.327.216.589.393.85.571.284.194.568.387.936.629.093.06.183.125.27.187.331.236.63.448.997.414.214-.02.435-.22.547-.82.265-1.417.786-4.486.906-5.751a1.426 1.426 0 0 0-.013-.315.337.337 0 0 0-.114-.217.526.526 0 0 0-.31-.093c-.3.005-.763.166-2.984 1.09z" />
            </svg>
          </a> */}
          {/* <a
            rel="noopener noreferrer"
            href="#!"
            target="_blank"
            className="mx-3 text-rose-600 group"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              fill="currentColor"
              className="duration-500 bi bi-youtube group-hover:scale-125"
              viewBox="0 0 16 16"
            >
              <path d="M8.051 1.999h.089c.822.003 4.987.033 6.11.335a2.01 2.01 0 0 1 1.415 1.42c.101.38.172.883.22 1.402l.01.104.022.26.008.104c.065.914.073 1.77.074 1.957v.075c-.001.194-.01 1.108-.082 2.06l-.008.105-.009.104c-.05.572-.124 1.14-.235 1.558a2.007 2.007 0 0 1-1.415 1.42c-1.16.312-5.569.334-6.18.335h-.142c-.309 0-1.587-.006-2.927-.052l-.17-.006-.087-.004-.171-.007-.171-.007c-1.11-.049-2.167-.128-2.654-.26a2.007 2.007 0 0 1-1.415-1.419c-.111-.417-.185-.986-.235-1.558L.09 9.82l-.008-.104A31.4 31.4 0 0 1 0 7.68v-.123c.002-.215.01-.958.064-1.778l.007-.103.003-.052.008-.104.022-.26.01-.104c.048-.519.119-1.023.22-1.402a2.007 2.007 0 0 1 1.415-1.42c.487-.13 1.544-.21 2.654-.26l.17-.007.172-.006.086-.003.171-.007A99.788 99.788 0 0 1 7.858 2h.193zM6.4 5.209v4.818l4.157-2.408L6.4 5.209z" />
            </svg>
          </a>{" "} */}
          {/* <a
            rel="noopener noreferrer"
            target="_blank"
            href="https://invite.viber.com/?g2=AQBo0NZh1%2FvGlE3%2FRCTubGhAGcdTHSVERm%2FBsl8ZX6P2FNfAftJG4pzOI3jG4zw4"
            className="mx-3 text-indigo-600 group"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              className="duration-500 group-hover:scale-125"
              preserveAspectRatio="xMidYMid meet"
              viewBox="0 0 24 24"
            >
              <path
                fill="currentColor"
                d="M11.4 0C9.473.028 5.333.344 3.02 2.467C1.302 4.187.696 6.7.633 9.817C.57 12.933.488 18.776 6.12 20.36h.003l-.004 2.416s-.037.977.61 1.177c.777.242 1.234-.5 1.98-1.302c.407-.44.972-1.084 1.397-1.58c3.85.326 6.812-.416 7.15-.525c.776-.252 5.176-.816 5.892-6.657c.74-6.02-.36-9.83-2.34-11.546c-.596-.55-3.006-2.3-8.375-2.323c0 0-.395-.025-1.037-.017zm.058 1.693c.545-.004.88.017.88.017c4.542.02 6.717 1.388 7.222 1.846c1.675 1.435 2.53 4.868 1.906 9.897v.002c-.604 4.878-4.174 5.184-4.832 5.395c-.28.09-2.882.737-6.153.524c0 0-2.436 2.94-3.197 3.704c-.12.12-.26.167-.352.144c-.13-.033-.166-.188-.165-.414l.02-4.018c-4.762-1.32-4.485-6.292-4.43-8.895c.054-2.604.543-4.738 1.996-6.173c1.96-1.773 5.474-2.018 7.11-2.03zm.38 2.602a.304.304 0 0 0-.004.607c1.624.01 2.946.537 4.028 1.592c1.073 1.046 1.62 2.468 1.633 4.334c.002.167.14.3.307.3a.304.304 0 0 0 .3-.304c-.014-1.984-.618-3.596-1.816-4.764c-1.19-1.16-2.692-1.753-4.447-1.765zm-3.96.695a.981.981 0 0 0-.616.117l-.01.002c-.43.247-.816.562-1.146.932c-.002.004-.006.004-.008.008c-.267.323-.42.638-.46.948a.596.596 0 0 0-.007.14c0 .136.022.27.065.4l.013.01c.135.48.473 1.276 1.205 2.604c.42.768.903 1.5 1.446 2.186c.27.344.56.673.87.984l.132.132c.31.308.64.6.984.87a15.524 15.524 0 0 0 2.186 1.447c1.328.733 2.126 1.07 2.604 1.206l.01.014a1.275 1.275 0 0 0 .54.055c.31-.036.627-.19.948-.46c.004 0 .003-.002.008-.005c.37-.33.683-.72.93-1.148l.003-.01c.225-.432.15-.842-.18-1.12c-.004 0-.698-.58-1.037-.83c-.36-.255-.73-.492-1.113-.71c-.51-.285-1.032-.106-1.248.174l-.447.564c-.23.283-.657.246-.657.246c-3.12-.796-3.955-3.955-3.955-3.955s-.037-.426.248-.656l.563-.448c.277-.215.456-.737.17-1.248a12.73 12.73 0 0 0-.71-1.115a28.35 28.35 0 0 0-.83-1.035a.822.822 0 0 0-.502-.297zm4.49.88a.303.303 0 0 0-.018.606c1.16.085 2.017.466 2.645 1.15c.63.688.93 1.524.906 2.57a.306.306 0 0 0 .61.013c.025-1.175-.334-2.193-1.067-2.994c-.74-.81-1.777-1.253-3.05-1.346h-.024zm.463 1.63a.305.305 0 0 0-.3.287c-.008.167.12.31.288.32c.523.028.875.175 1.113.422c.24.245.388.62.416 1.164a.304.304 0 0 0 .605-.03c-.03-.644-.215-1.178-.58-1.557c-.367-.378-.893-.574-1.52-.607h-.018z"
              />
            </svg>
          </a> */}
          {/* <a
            rel="noopener noreferrer"
            href="https://www.tiktok.com/@vary_pharmacy"
            target="_blank"
            className="mx-3 text-cyan-600 group"
          >
            <svg
              className="duration-500 group-hover:scale-125"
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              fill="#000000"
              viewBox="0 0 256 256"
            >
              <path d="M224,72a48.05,48.05,0,0,1-48-48,8,8,0,0,0-8-8H128a8,8,0,0,0-8,8V156a20,20,0,1,1-28.57-18.08A8,8,0,0,0,96,130.69V88a8,8,0,0,0-9.4-7.88C50.91,86.48,24,119.1,24,156a76,76,0,0,0,152,0V116.29A103.25,103.25,0,0,0,224,128a8,8,0,0,0,8-8V80A8,8,0,0,0,224,72Zm-8,39.64a87.19,87.19,0,0,1-43.33-16.15A8,8,0,0,0,160,102v54a60,60,0,0,1-120,0c0-25.9,16.64-49.13,40-57.6v27.67A36,36,0,1,0,136,156V32h24.5A64.14,64.14,0,0,0,216,87.5Z"></path>
            </svg>
          </a> */}
          {/* <Link to="#!" className={` text-gray-600 ${locale}`}>
            <svg
              aria-hidden="true"
              focusable="false"
              data-prefix="fab"
              data-icon="github"
              className="w-4"
              role="img"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 496 512"
            >
              <path
                fill="currentColor"
                d="M165.9 397.4c0 2-2.3 3.6-5.2 3.6-3.3.3-5.6-1.3-5.6-3.6 0-2 2.3-3.6 5.2-3.6 3-.3 5.6 1.3 5.6 3.6zm-31.1-4.5c-.7 2 1.3 4.3 4.3 4.9 2.6 1 5.6 0 6.2-2s-1.3-4.3-4.3-5.2c-2.6-.7-5.5.3-6.2 2.3zm44.2-1.7c-2.9.7-4.9 2.6-4.6 4.9.3 2 2.9 3.3 5.9 2.6 2.9-.7 4.9-2.6 4.6-4.6-.3-1.9-3-3.2-5.9-2.9zM244.8 8C106.1 8 0 113.3 0 252c0 110.9 69.8 205.8 169.5 239.2 12.8 2.3 17.3-5.6 17.3-12.1 0-6.2-.3-40.4-.3-61.4 0 0-70 15-84.7-29.8 0 0-11.4-29.1-27.8-36.6 0 0-22.9-15.7 1.6-15.4 0 0 24.9 2 38.6 25.8 21.9 38.6 58.6 27.5 72.9 20.9 2.3-16 8.8-27.1 16-33.7-55.9-6.2-112.3-14.3-112.3-110.5 0-27.5 7.6-41.3 23.6-58.9-2.6-6.5-11.1-33.3 2.6-67.9 20.9-6.5 69 27 69 27 20-5.6 41.5-8.5 62.8-8.5s42.8 2.9 62.8 8.5c0 0 48.1-33.6 69-27 13.7 34.7 5.2 61.4 2.6 67.9 16 17.7 25.8 31.5 25.8 58.9 0 96.5-58.9 104.2-114.8 110.5 9.2 7.9 17 22.9 17 46.4 0 33.7-.3 75.4-.3 83.6 0 6.5 4.6 14.4 17.3 12.1C428.2 457.8 496 362.9 496 252 496 113.3 383.5 8 244.8 8zM97.2 352.9c-1.3 1-1 3.3.7 5.2 1.6 1.6 3.9 2.3 5.2 1 1.3-1 1-3.3-.7-5.2-1.6-1.6-3.9-2.3-5.2-1zm-10.8-8.1c-.7 1.3.3 2.9 2.3 3.9 1.6 1 3.6.7 4.3-.7.7-1.3-.3-2.9-2.3-3.9-2-.6-3.6-.3-4.3.7zm32.4 35.6c-1.6 1.3-1 4.3 1.3 6.2 2.3 2.3 5.2 2.6 6.5 1 1.3-1.3.7-4.3-1.3-6.2-2.2-2.3-5.2-2.6-6.5-1zm-11.4-14.7c-1.6 1-1.6 3.6 0 5.9 1.6 2.3 4.3 3.3 5.6 2.3 1.6-1.3 1.6-3.9 0-6.2-1.4-2.3-4-3.3-5.6-2z"
              ></path>
            </svg>
          </Link> */}
        </div>
      </div>
      <div className="py-10 mx-6 text-center md:text-left">
        <div className="grid gap-8 grid-1 md:grid-cols-2 lg:grid-cols-4">
          <div className="">
            <h6
              className={`flex items-center justify-center mb-4 font-semibold uppercase md:justify-start bg-clip-text hover:bg-gradient-to-br from-pink-600 to-pink-700 ${locale}`}
            >
              <img
                src={Configuration[0]?.imageUrl}
                className={`inline w-16 ${locale}`}
              />
              {/* {t("varyPharmacy")} */}
              {locale === "en-US" && Configuration[0]?.englishName}
              {locale === "ar" && Configuration[0]?.arabicName}
              {locale === "ku" && Configuration[0]?.kurdishName}
            </h6>
            <p
              className={`${locale} text-md hover:text-pink-600 duration-500 ${
                locale === "en-US" ? " text-left" : "text-right"
              }`}
            >
              {locale === "en-US" && Configuration[0]?.englishAbout}
              {locale === "ar" && Configuration[0]?.arabicAbout}
              {locale === "ku" && Configuration[0]?.kurdishAbout}
            </p>
            {/* <p
              className={`${locale} text-md sm:text-center hover:text-pink-600 duration-500 ${
                locale === "en-US" ? " text-left" : "text-right"
              }`}
            >
              {t("varyMot")}
            </p> */}
            {/* <!-- component --> */}
            {/* <!-- This is an example component --> */}
            <div className="max-w-2xl mx-auto mt-4">
              <div className="w-full text-center bg-white rounded-lg md dark:bg-gray-800 dark:border-gray-700">
                <div className="items-center space-x-4 space-y-4 justify-evenly sm:flex sm:space-y-0">
                  <a
                    href="https://apps.apple.com/us/app/vary-healthcare/id6471336461"
                    target="_blank"
                    className="lg:mx-2 w-full sm:w-auto flex bg-gradient-to-br from-secondary-500 to-secondary-600 hover:scale-105 duration-500 focus:ring-4 focus:ring-gray-300 text-white rounded-lg inline-flex items-center justify-center px-6 py-2.5 dark:bg-gray-700 dark:hover:bg-gray-600 dark:focus:ring-gray-700" rel="noreferrer"
                  >
                    <svg
                      className={`${
                        locale === "en-US" ? "mr-3" : "ml-3"
                      } w-7 h-7`}
                      aria-hidden="true"
                      focusable="false"
                      data-prefix="fab"
                      data-icon="apple"
                      role="img"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 384 512"
                    >
                      <path
                        fill="currentColor"
                        d="M318.7 268.7c-.2-36.7 16.4-64.4 50-84.8-18.8-26.9-47.2-41.7-84.7-44.6-35.5-2.8-74.3 20.7-88.5 20.7-15 0-49.4-19.7-76.4-19.7C63.3 141.2 4 184.8 4 273.5q0 39.3 14.4 81.2c12.8 36.7 59 126.7 107.2 125.2 25.2-.6 43-17.9 75.8-17.9 31.8 0 48.3 17.9 76.4 17.9 48.6-.7 90.4-82.5 102.6-119.3-65.2-30.7-61.7-90-61.7-91.9zm-56.6-164.2c27.3-32.4 24.8-61.9 24-72.5-24.1 1.4-52 16.4-67.9 34.9-17.5 19.8-27.8 44.3-25.6 71.9 26.1 2 49.9-11.4 69.5-34.3z"
                      ></path>
                    </svg>
                    <div
                      className={` ${
                        locale === "en-US" ? "text-left" : "text-right"
                      }`}
                    >
                      <div className={`mb-1 text-xs ${locale}`}>
                        {t("varyOn")}
                      </div>
                      <div className={`-mt-1 text-sm ${locale}`}>
                        {t("appStore")}
                      </div>
                    </div>
                  </a>
                  <a
                    href="https://play.google.com/store/apps/details?id=com.varyhealthcare.app.varyhealthcare.vary_healthcare_app&hl=en&gl=US"
                    target="_blank"
                    className="w-full sm:w-auto flex bg-gradient-to-br from-pink-600 to-pink-500 hover:scale-105 duration-500 focus:ring-4 focus:ring-gray-300 text-white rounded-lg inline-flex items-center justify-center px-6 py-2.5 dark:bg-gray-700 dark:hover:bg-gray-600 dark:focus:ring-gray-700"
                  >
                    <svg
                      className={`${
                        locale === "en-US" ? "mr-3" : "ml-3"
                      } w-7 h-7`}
                      aria-hidden="true"
                      focusable="false"
                      data-prefix="fab"
                      data-icon="google-play"
                      role="img"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 512 512"
                    >
                      <path
                        fill="currentColor"
                        d="M325.3 234.3L104.6 13l280.8 161.2-60.1 60.1zM47 0C34 6.8 25.3 19.2 25.3 35.3v441.3c0 16.1 8.7 28.5 21.7 35.3l256.6-256L47 0zm425.2 225.6l-58.9-34.1-65.7 64.5 65.7 64.5 60.1-34.1c18-14.3 18-46.5-1.2-60.8zM104.6 499l280.8-161.2-60.1-60.1L104.6 499z"
                      ></path>
                    </svg>
                    <div
                      className={`${
                        locale === "en-US" ? "text-left" : "text-right"
                      }`}
                    >
                      <div className={`mb-1 text-xs ${locale}`}>
                        {t("varyOn")}
                      </div>
                      <div className={`-mt-1  text-sm ${locale}`}>
                        {t("playStore")}
                      </div>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="">
            <h6
              className={`flex items-center justify-center mb-4 font-semibold uppercase md:justify-start ${locale}`}
            >
              {t("varyInMap")}
            </h6>
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d51929.85846555059!2d45.33645551883231!3d35.5631809642804!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40002c0536d143b1%3A0xf791750d4e215dea!2sSulaymaniyah!5e0!3m2!1sen!2siq!4v1690977193266!5m2!1sen!2siq"
              // src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d6491.719411771331!2d45.445821200000005!3d35.5571669!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40002d5399ef8ae5%3A0x731f85a852c27174!2z2K_bldix2YXYp9mG2K7Yp9mG25XbjCDapNin2LHbjCB2YXJ5IHBoYXJtYWN5!5e0!3m2!1sen!2siq!4v1650707945699!5m2!1sen!2siq"
              width="100%"
              // height="200"
              // style={{pointerEvents: }}
            ></iframe>
          </div>
          <div className="">
            <h6
              className={`flex justify-center mb-4 font-semibold uppercase md:justify-start ${locale} ${
                locale === "en-US" ? "text-left" : "text-right"
              }`}
            >
              {t("sections")}
            </h6>
            <p
              className={`mb-4 ${locale} ${
                locale === "en-US" ? "md:text-left" : "md:text-right"
              }`}
            >
              <Link
                to="/shop"
                className={`text-gray-600 hover:text-pink-600 duration-500 hover:underline ${locale}`}
              >
                {t("shop")}
              </Link>
            </p>
            <p
              className={`mb-4 ${locale} ${
                locale === "en-US" ? "md:text-left" : "md:text-right"
              }`}
            >
              <Link
                to="/offers"
                className={` text-gray-600 hover:text-pink-600 duration-500 hover:underline ${locale}`}
              >
                {t("offers")}
              </Link>
            </p>
            <p
              className={`mb-4 ${locale} ${
                locale === "en-US" ? "md:text-left" : "md:text-right"
              }`}
            >
              <Link
                to="/askvary"
                className={` text-gray-600 hover:text-pink-600 duration-500 hover:underline ${locale}`}
              >
                {t("askVary")}
              </Link>
            </p>
            <p
              className={`mb-4 ${locale} ${
                locale === "en-US" ? "md:text-left" : "md:text-right"
              }`}
            >
              <Link
                to="/information"
                className={` text-gray-600 hover:text-pink-600 duration-500 hover:underline ${locale}`}
              >
                {t("information")}
              </Link>
            </p>
          </div>

          <div className="">
            <h6
              className={`flex justify-center mb-4 font-semibold uppercase md:justify-start ${locale}`}
            >
              {t("contact")}
            </h6>
            <p
              className={`flex items-center justify-center mb-4 md:justify-start hover:text-pink-600 duration-500 ${locale} ${
                locale === "en-US" ? "" : "text-right"
              }`}
            >
              <MapPinIcon
                className={`w-4 ${locale === "en-US" ? "mr-4" : "ml-4"}`}
              />
              {/* {t("varyAddress")} */}
              {locale === "en-US" && contacts[0]?.englishAddress}
              {locale === "ku" && contacts[0]?.kurdishAddress}
              {locale === "ar" && contacts[0]?.arabicAddress}
            </p>
            <p
              className={`flex items-center justify-center mb-4 md:justify-start hover:text-pink-600 duration-500 ${
                locale === "en-US" ? "" : " font-bold"
              }`}
            >
              <EnvelopeIcon
                className={`w-4 ${locale === "en-US" ? "mr-4" : "ml-4"}`}
              />
              {/* vary.pharmacy@hotmail.com */}
              {contacts[0]?.emailAddress}
            </p>
            <p
              className={`flex items-center justify-center mb-4 md:justify-start hover:text-pink-600 duration-500 ${
                locale === "en-US" ? "" : " font-bold"
              }`}
            >
              {/* <svg
                aria-hidden="true"
                focusable="false"
                data-prefix="fas"
                data-icon="phone"
                className={`w-4 ${locale === "en-US" ? "mr-4" : "ml-4"}`}
                role="img"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 512 512"
              >
                <path
                  fill="currentColor"
                  d="M493.4 24.6l-104-24c-11.3-2.6-22.9 3.3-27.5 13.9l-48 112c-4.2 9.8-1.4 21.3 6.9 28l60.6 49.6c-36 76.7-98.9 140.5-177.2 177.2l-49.6-60.6c-6.8-8.3-18.2-11.1-28-6.9l-112 48C3.9 366.5-2 378.1.6 389.4l24 104C27.1 504.2 36.7 512 48 512c256.1 0 464-207.5 464-464 0-11.2-7.7-20.9-18.6-23.4z"
                ></path>
              </svg> */}
              <PhoneIcon
                className={`w-4 ${locale === "en-US" ? "mr-4" : "ml-4"}`}
              />
              {/* {t("phoneNumber")} */}
              {contacts[0]?.primaryPhoneNumber}
            </p>
            <p
              className={`flex items-center justify-center md:justify-start hover:text-pink-600 duration-500 ${
                locale === "en-US" ? "" : " font-bold"
              }`}
            >
              {/* <svg
                aria-hidden="true"
                focusable="false"
                data-prefix="fas"
                data-icon="print"
                className={`w-4 ${locale === "en-US" ? "mr-4" : "ml-4"}`}
                role="img"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 512 512"
              >
                <path
                  fill="currentColor"
                  d="M448 192V77.25c0-8.49-3.37-16.62-9.37-22.63L393.37 9.37c-6-6-14.14-9.37-22.63-9.37H96C78.33 0 64 14.33 64 32v160c-35.35 0-64 28.65-64 64v112c0 8.84 7.16 16 16 16h48v96c0 17.67 14.33 32 32 32h320c17.67 0 32-14.33 32-32v-96h48c8.84 0 16-7.16 16-16V256c0-35.35-28.65-64-64-64zm-64 256H128v-96h256v96zm0-224H128V64h192v48c0 8.84 7.16 16 16 16h48v96zm48 72c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24z"
                ></path>
              </svg> */}
              <PhoneIcon
                className={`w-4 ${locale === "en-US" ? "mr-4" : "ml-4"}`}
              />
              {/* {t("normalPhone")} */}
              {contacts[0]?.secondaryPhoneNumber}
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
